import dayjs from "dayjs";

//Function to check if a value is not numeric
export const isNotNumeric = (str) => {
  return !/^\d+$/.test(str);
};

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

export const booleanCheck = (val) => {
  if (typeof val === "string") {
    if (val === "0") return false;
    if (val === "1") return true;
  }

  return false;
};

export const toBoolean = (val) => {
  if (typeof val === "string" && (val === "0" || val === "1")) {
    return true;
  }
  return false;
};

export const isValidFutureDate = (dateStr) => {
  // Match d/m/yyyy or dd/mm/yyyy format (with optional leading zeros)
  const dateRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const match = dateStr.match(dateRegex);

  if (!match) return false; // Invalid format

  // eslint-disable-next-line no-unused-vars
  const [_, dd, mm, yyyy] = match;

  // Pad day and month with leading zeros if needed
  const paddedDD = dd.padStart(2, "0");
  const paddedMM = mm.padStart(2, "0");

  // Create a date object (JS months are 0-based)
  const dateObj = new Date(`${yyyy}-${paddedMM}-${paddedDD}`);

  // Check if the date is valid
  if (isNaN(dateObj.getTime())) return false;

  // Ensure day/month/year still match after parsing
  if (
    dateObj.getDate() !== Number(dd) ||
    dateObj.getMonth() + 1 !== Number(mm) ||
    dateObj.getFullYear() !== Number(yyyy)
  ) {
    return false;
  }

  // Get today's date without time
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  dateObj.setHours(0, 0, 0, 0);

  return dateObj >= today;
};

export const getTodayDateDDMMYYYY = () => {
  const today = new Date();

  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const yyyy = today.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};

export function getFullImageUrl(imgPath) {
  if (!imgPath) return "";
  return imgPath.startsWith("http") ? imgPath : `${process.env.REACT_APP_IMAGE_URL}${imgPath}`;
}

// disable past date and today's date
export const dobDisabledDate = (current) => {
  const today = dayjs().subtract(1, "day"); // Subtract 1 day from today
  const eighteenYearsAgo = today.subtract(18, "year");
  const hundredYearsAgo = today.subtract(100, "year");
  return (
    current &&
    (current.isAfter(eighteenYearsAgo, "day") || current.isBefore(hundredYearsAgo, "day"))
  );
};

export const generateFinancialYearOptions = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1; // getMonth() is zero-based

  // If before April, the current financial year is still the previous one
  const latestYear = currentMonth < 4 ? currentYear - 1 : currentYear;

  const financialYears = [];

  for (let i = 0; i < 3; i++) {
    const startYear = latestYear - i;
    const endYear = startYear + 1;
    const yearRange = `${startYear}-${endYear}`;

    financialYears.push({
      value: yearRange,
      label: yearRange
    });
  }

  return financialYears; // Reverse to have the latest year first
};

export const dateFormatFn = (d, format) => {
  return dayjs(d).format(format);
};

export function getKYCStatus(dm = {}) {
  switch (true) {
    case dm.kyc_status === "A":
      return "KYC OK";

    case dm.kyc_status === "I" && dm.SRNO > 0:
      return "KYC Not OK";

    case dm.kyc_status === "A" && dm.terminated === "Y" && dm.srno === "":
      return "Resignation";

    case dm.kyc_status === "A" && dm.terminated === "Y" && dm.srno === "Not Renew":
      return "Not Renew";

    default:
      return "KYC Pending";
  }
}

export const modifyFileName = (fileName) => {
  const result = fileName.replace("mdm/public/", "");
  return result;
};

export const generateABName = (DM = {}) => {
  let name = DM?.dist_name || DM?.distributor_name || DM.title;
  let dist_no = DM.dist_no || DM.ab_number || "";
  if (DM.kyc_status === "I" && DM.srno > 0) {
    return `[${dist_no}] KYC NOT OK - ${DM.title}`;
  }

  if (
    DM.kyc_status === "A" &&
    (DM.terminated === "true" || DM.terminated === true) &&
    DM.remark === "Terminate"
  ) {
    return `[${dist_no}] Terminated - ${DM.title}`;
  }

  if (DM.kyc_status === "I" && DM.srno === 0) {
    return `[${dist_no}] KYC NOT SUBMITTED - ${DM.title}`;
  }

  if (
    DM.kyc_status === "A" &&
    (DM.terminated === "true" || DM.terminated === true) &&
    DM.remark === ""
  ) {
    return `[${dist_no}] Resignation - ${DM.title}`;
  }

  if (
    DM.kyc_status === "A" &&
    (DM.terminated === "true" || DM.terminated === true) &&
    DM.remark === "Not Renew"
  ) {
    return `[${dist_no}] Not Renew - ${DM.title}`;
  }

  return `[${dist_no}] ${name}`;
};
